/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  Ping,
  GetSummary200,
  ListCountries200AllOf,
  ListPositions200AllOf,
  ListOccupations200AllOf,
  Webhook,
  RemoveWebhookBody,
  ListWebhooks200,
  CreateWebhookBody,
  ListAccounts200,
  ListAccountsParams,
  Account,
  CreateAccountBody,
  UpdateAccountName200,
  UpdateAccountNameBody,
  AddAssetsToAccountBody,
  RemoveAssetFromAccountBody,
  GetAccountsBalances200,
  GetAccountsBalancesParams,
  AccountTransfer,
  PostAccountsTransfersBody,
  GetAccountTransactions200,
  GetAccountTransactionsParams,
  GetCardAccounts200,
  GetCardAccountsParams,
  CardAccount,
  CreateCardAccountBody,
  Card,
  IssueCardBody,
  GetCards200,
  GetCardsParams,
  GetCardAccountTransactions200,
  GetCardAccountTransactionsParams,
  ActivateCardBody,
  SuspendCardBody,
  UnsuspendCardBody,
  LockCardBody,
  UnlockCardBody,
  CancelCardBody,
  GetCardSensitiveDetails200,
  GetCardSensitiveDetailsParams,
  ChangeCardPinBody,
  PostCardsSpendingControlsBody,
  UpdateCardPhoneNumber200,
  UpdateCardPhoneNumberBody,
  SimulateAuthorization200,
  SimulateAuthorizationBody,
  SimulateCapture200,
  SimulateCaptureBody,
  VerifyCardInfo200,
  VerifyCardInfoBody,
  DigitalAsset,
  Blockchain,
  DigitalWithdrawalRequest,
  WithdrawDigitalAssetBody,
  GetDepositAddresses200,
  GetDepositAddressesParams,
  DigitalDepositAddress,
  GenerateDepositAddressBody,
  GetPayouts200,
  GetPayoutsParams,
  Payout,
  CreatePayoutBody,
  ValidatePayout200,
  ValidatePayoutBody,
  PayoutQuote,
  GetPayoutQuoteBody,
  GetConversionQuote200,
  GetConversionQuoteBody,
  ExecuteQuotedTrade200,
  ExecuteQuotedTradeBody,
  CardAccountTransaction,
  TransferCardAccountBody,
  TopupCardAccountBody,
  WithdrawCardAccountBody,
  SimulateRepayCardAccount200,
  SimulateRepayCardAccountBody,
  GetFees200,
  GetFeesParams,
  FeeEntry,
  ChargeFeeBody,
  WaiveFeeBody,
  GetRates200,
  GetRatesParams,
  GetBanks200,
  GetBanksParams,
  GetNameCheckId200,
  PostNameCheck200,
  PostNameCheckBody,
  PostXmetadataSet200,
  PostXmetadataSetBody,
  GetReportingAccountsTransactions200,
  GetReportingAccountsTransactionsParams,
  GetReportingCardaccountsTransactions200,
  GetReportingCardaccountsTransactionsParams,
  PostCardaccountsFixedLimitBody,
  PostCardaccountsClientIdentity200,
  PostCardaccountsClientIdentityBody,
  GetCardaccountsClientIdentity200,
  GetCardaccountsClientIdentityParams,
  GetUiAccountsBalances200,
  GetUiAccountsBalancesParams,
  UiListAccounts200,
  UiListAccountsParams,
  GetAccountsCreditSummary200,
  GetAccountsCreditSummaryParams
} from './schema'




  export const getAPIReference = () => {
/**
 * Test API Connectivity to Access API and retrieve server time
 * @summary Test connectivity
 */
const pingGet = <TData = AxiosResponse<Ping>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/ping`,options
    );
  }

/**
 * Test API Connectivity to Access API and retrieve server time
 * @summary Test connectivity
 */
const pingPost = <TData = AxiosResponse<Ping>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/ping`,undefined,options
    );
  }

/**
 * @summary Get summary
 */
const getSummary = <TData = AxiosResponse<GetSummary200>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/summary`,options
    );
  }

/**
 * Get a list of Countries
 * @summary Get Countries
 */
const listCountries = <TData = AxiosResponse<ListCountries200AllOf>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/countries`,options
    );
  }

/**
 * Get a list of Positions
 * @summary Get Positions
 */
const listPositions = <TData = AxiosResponse<ListPositions200AllOf>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/positions`,options
    );
  }

/**
 * Get a list of Occupations
 * @summary Get Occupations
 */
const listOccupations = <TData = AxiosResponse<ListOccupations200AllOf>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/occupations`,options
    );
  }

/**
 * Remove a Webhook
 * @summary Remove Webhook
 */
const removeWebhook = <TData = AxiosResponse<Webhook>>(
    removeWebhookBody: RemoveWebhookBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/webhooks/remove`,
      removeWebhookBody,options
    );
  }

/**
 * List all Webhooks

 * @summary List Webhooks
 */
const listWebhooks = <TData = AxiosResponse<ListWebhooks200>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/webhooks`,options
    );
  }

/**
 * Create a Webhook to receive notifications when an event occurs

 * @summary Create Webhook
 */
const createWebhook = <TData = AxiosResponse<Webhook>>(
    createWebhookBody: CreateWebhookBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/webhooks`,
      createWebhookBody,options
    );
  }

/**
 * Get a collection of Accounts based on provided search criteria.
 * @summary Get Accounts
 */
const listAccounts = <TData = AxiosResponse<ListAccounts200>>(
    params?: ListAccountsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/accounts`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Create Account
 * @summary Create Account
 */
const createAccount = <TData = AxiosResponse<Account>>(
    createAccountBody: CreateAccountBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/accounts`,
      createAccountBody,options
    );
  }

/**
 * Update the display name of an existing account. The account must belong to the authenticated user.

 * @summary Update Account Name
 */
const updateAccountName = <TData = AxiosResponse<UpdateAccountName200>>(
    updateAccountNameBody: UpdateAccountNameBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/accounts/update-name`,
      updateAccountNameBody,options
    );
  }

/**
 * This endpoint is used to add one or more assets to an existing account. Assets that already exist in the given account will be ignored.

 * @summary Add Assets to Account
 */
const addAssetsToAccount = <TData = AxiosResponse<Account>>(
    addAssetsToAccountBody: AddAssetsToAccountBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/accounts/add-assets`,
      addAssetsToAccountBody,options
    );
  }

/**
 * This endpoint is used to remove one or more assets from an existing account. Assets that do not exist in the given account will be ignored. Asset that have a balance or have transcated will not be removed.

 * @summary Remove Assets from Account
 */
const removeAssetFromAccount = <TData = AxiosResponse<Account>>(
    removeAssetFromAccountBody: RemoveAssetFromAccountBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/accounts/remove-assets`,
      removeAssetFromAccountBody,options
    );
  }

/**
 * Retrieves the balances of account(s).
 * @summary Get Balances
 */
const getAccountsBalances = <TData = AxiosResponse<GetAccountsBalances200>>(
    params?: GetAccountsBalancesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/accounts/balances`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Real-time off-chain funds transfers between two accounts on UTGL Network.
The source account available balance must be able to cover the transfer amount.

This endpoint is used for any internal transfer. For asset backed credit cards, this function is used for top-up an asset backed account.
 * @summary Create a Transfer
 */
const postAccountsTransfers = <TData = AxiosResponse<AccountTransfer>>(
    postAccountsTransfersBody: PostAccountsTransfersBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/accounts/transfers`,
      postAccountsTransfersBody,options
    );
  }

/**
 * Retrieve a collection of account transactions in reverse chronological order
 * @summary Get Account Transactions
 */
const getAccountTransactions = <TData = AxiosResponse<GetAccountTransactions200>>(
    params?: GetAccountTransactionsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/accounts/transactions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Get a list of Card Accounts
 * @summary Get Card Accounts
 */
const getCardAccounts = <TData = AxiosResponse<GetCardAccounts200>>(
    params?: GetCardAccountsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/cardaccounts`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Create a card account

 * @summary Create Card Account
 */
const createCardAccount = <TData = AxiosResponse<CardAccount>>(
    createCardAccountBody: CreateCardAccountBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cardaccounts`,
      createCardAccountBody,options
    );
  }

/**
 * Issue a card under the respective card account.

This can be either a physical, which is a traditional tangible card made of plastic, or a virtual card, which is a digital version of a physical card that can be used for online transactions or transactions made through a mobile device.

When issuing a card, the productId must be specified and determines the card product to issue. The card product determines the card type, card face, card features, benefits, interest rates, capabilties, etc. The list of available productIds is static will be provided by your solution manager based on your pre-determined card product offering(s).
The card will be chosen from the available inventory and given out in numerical order according to its card number.

If you wish to issue a specific card, you may specify the card number suffix (up to the full card numberA) using the `cardSuffix` field. If the card number is not part of the `productId` or already issued, the request will fail.

Multiple cards can be issued under the a single card account.

Once the request has been processed:
- The card will be created in the system under the respective card account.
- The card can then be activated and used for making purchases.
 * @summary Issue Card
 */
const issueCard = <TData = AxiosResponse<Card>>(
    issueCardBody: IssueCardBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cards`,
      issueCardBody,options
    );
  }

/**
 * Get Cards
 * @summary Get Cards
 */
const getCards = <TData = AxiosResponse<GetCards200>>(
    params: GetCardsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/cards`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Get Card Account Transactions
 * @summary Get Card Account Transactions
 */
const getCardAccountTransactions = <TData = AxiosResponse<GetCardAccountTransactions200>>(
    params: GetCardAccountTransactionsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/cardaccounts/transactions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Activate a card
 * @summary Activate Card
 */
const activateCard = <TData = AxiosResponse<Card>>(
    activateCardBody: ActivateCardBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cards/activate`,
      activateCardBody,options
    );
  }

/**
 * Suspend a card. Immediately prevents card from further transactions and can only be reactivated by operator using the unsuspend endpoint.

 * @summary Suspend Card
 */
const suspendCard = <TData = AxiosResponse<Card>>(
    suspendCardBody: SuspendCardBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cards/suspend`,
      suspendCardBody,options
    );
  }

/**
 * Unsuspend a card
 * @summary Unsuspend Card
 */
const unsuspendCard = <TData = AxiosResponse<Card>>(
    unsuspendCardBody: UnsuspendCardBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cards/unsuspend`,
      unsuspendCardBody,options
    );
  }

/**
 * Lock a card. Immediately prevents further transactions. Card can be unlocked immediately using the unlock endpoint.

Card Lock & Unlock functionality is designed for client use.

 * @summary Lock Card
 */
const lockCard = <TData = AxiosResponse<Card>>(
    lockCardBody: LockCardBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cards/lock`,
      lockCardBody,options
    );
  }

/**
 * Unlock a locked card. Immediately allows subsequent card transactions upon unlocking.

Card Lock & Unlock functionality is designed for client use. For operator use, use the suspend and unsuspend endpoints.

 * @summary Unlock Card
 */
const unlockCard = <TData = AxiosResponse<Card>>(
    unlockCardBody: UnlockCardBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cards/unlock`,
      unlockCardBody,options
    );
  }

/**
 * Request card cancellation, if the card is active, it will be deactivated immediately and no further card charges will go through.
 * @summary Cancel a card
 */
const cancelCard = <TData = AxiosResponse<Card>>(
    cancelCardBody: CancelCardBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cards/cancel`,
      cancelCardBody,options
    );
  }

/**
 * @summary Get Card Sensitive Info
 */
const getCardSensitiveDetails = <TData = AxiosResponse<GetCardSensitiveDetails200>>(
    params: GetCardSensitiveDetailsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/cards/card-sensitive-info`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Change Card ATM PIN for a card. Card ATM pin is used for ATM withdrawals and is effective immediately.
 */
const changeCardPin = <TData = AxiosResponse<void>>(
    changeCardPinBody: ChangeCardPinBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cards/change-pin`,
      changeCardPinBody,options
    );
  }

/**
 * By setting a value for these fields, the cardholder can ensure that their card spending is limited to a specified amount each day.

If either limit is not desired, it can be disabled by setting the value to null.

 * @summary Control Spending
 */
const postCardsSpendingControls = <TData = AxiosResponse<Card>>(
    postCardsSpendingControlsBody: PostCardsSpendingControlsBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cards/spending-controls`,
      postCardsSpendingControlsBody,options
    );
  }

/**
 * Update the phone number for a card.
 */
const updateCardPhoneNumber = <TData = AxiosResponse<UpdateCardPhoneNumber200>>(
    updateCardPhoneNumberBody: UpdateCardPhoneNumberBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cards/update-phone`,
      updateCardPhoneNumberBody,options
    );
  }

/**
 * Simulate a card authorization on a given card
 * @summary Simulate Authorization
 */
const simulateAuthorization = <TData = AxiosResponse<SimulateAuthorization200>>(
    simulateAuthorizationBody: SimulateAuthorizationBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cards/simulate-authorization`,
      simulateAuthorizationBody,options
    );
  }

/**
 * Simulate capturing a transaction
 * @summary Simulate a clearing of an authorized transaction
 */
const simulateCapture = <TData = AxiosResponse<SimulateCapture200>>(
    simulateCaptureBody: SimulateCaptureBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cards/simulate-capture`,
      simulateCaptureBody,options
    );
  }

/**
 * Validate a card with it's product id, last 6 digits, expiry date.
 * @summary Validate a card with card info.
 */
const verifyCardInfo = <TData = AxiosResponse<VerifyCardInfo200>>(
    verifyCardInfoBody: VerifyCardInfoBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cards/validate-card-info`,
      verifyCardInfoBody,options
    );
  }

/**
 * Get supported digital assets and networks
 * @summary Get Supported Digital Assets
 */
const getSupportedDigitalAssets = <TData = AxiosResponse<DigitalAsset[]>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/digital-custody/assets`,options
    );
  }

/**
 * Get supported blockchains
 * @summary Get Supported Blockchains
 */
const getSupportedBlockchains = <TData = AxiosResponse<Blockchain[]>>(
     options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/digital-custody/chains`,options
    );
  }

/**
 * Create a Withdraw Request to withdraw digital asset from a account to a destination address
 * @summary Create Withdrawal Request
 */
const withdrawDigitalAsset = <TData = AxiosResponse<DigitalWithdrawalRequest>>(
    withdrawDigitalAssetBody: WithdrawDigitalAssetBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/digital-custody/withdrawal`,
      withdrawDigitalAssetBody,options
    );
  }

/**
 * Get a list of deposit addresses
 * @summary Get Deposit Addresses
 */
const getDepositAddresses = <TData = AxiosResponse<GetDepositAddresses200>>(
    params?: GetDepositAddressesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/digital-custody/deposit-addresses`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Generates a new blockchain deposit address for an account for a given asset/chain pair. UTGL may reuse addresses on blockchains that support reuse. For example, if you're generated two addresses for depositing USDC and USDC, both on Ethereum, you may see the same Ethereum address returned. This behaviour cannot be assumed and should not be relied upon. Your implementation should generate an address for each asset and chain you want to support.
Depositing cryptocurrency to a generated address will credit the associated account with the value of the deposit net of any fees (if applicable).
 * @summary Generate Deposit Address
 */
const generateDepositAddress = <TData = AxiosResponse<DigitalDepositAddress[]>>(
    generateDepositAddressBody: GenerateDepositAddressBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/digital-custody/deposit-addresses`,
      generateDepositAddressBody,options
    );
  }

/**
 * Retrieve a list of payouts
 * @summary Get Payouts
 */
const getPayouts = <TData = AxiosResponse<GetPayouts200>>(
    params?: GetPayoutsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/payouts`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Create a payout to an external destination
 * @summary Create Payout
 */
const createPayout = <TData = AxiosResponse<Payout>>(
    createPayoutBody: CreatePayoutBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/payouts`,
      createPayoutBody,options
    );
  }

/**
 * Validate payout parameters and destination before processing a payout request.
This endpoint is currently only supported for the UNIONPAY and ALIPAY method, and is intended to ensure that the payout request meets the necessary minimum criteria for successful processing. Note that even a pre-validated payout may still fail to be processed if the destination is invalid for other reasons not checked by this endpoint.
 * @summary Validate Payout Parameters
 */
const validatePayout = <TData = AxiosResponse<ValidatePayout200>>(
    validatePayoutBody: ValidatePayoutBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/payouts/validate`,
      validatePayoutBody,options
    );
  }

/**
 * @summary Get Payout Quotation
 */
const getPayoutQuote = <TData = AxiosResponse<PayoutQuote>>(
    getPayoutQuoteBody: GetPayoutQuoteBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/payouts/quote`,
      getPayoutQuoteBody,options
    );
  }

/**
 * Convert from one fungible asset to another and settle transactions without ever taking assets out of custody.
 * @summary Get a Quote
 */
const getConversionQuote = <TData = AxiosResponse<GetConversionQuote200>>(
    getConversionQuoteBody: GetConversionQuoteBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/conversions/quote`,
      getConversionQuoteBody,options
    );
  }

/**
 * Execute a trade that has been previously quoted
 * @summary Execute a trade
 */
const executeQuotedTrade = <TData = AxiosResponse<ExecuteQuotedTrade200>>(
    executeQuotedTradeBody: ExecuteQuotedTradeBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/conversion/execute`,
      executeQuotedTradeBody,options
    );
  }

/**
 * Transfer balances between two card accounts. This applies to credit card accounts operating in accountType `prepaid`  only'

The source and destination card accounts must be of the same currency and the source card account must have sufficient funds to complete the transfer.

 * @summary Balance Transfer
 */
const transferCardAccount = <TData = AxiosResponse<CardAccountTransaction>>(
    transferCardAccountBody: TransferCardAccountBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cardaccounts/transfer`,
      transferCardAccountBody,options
    );
  }

/**
 * Top up a card account with funds from an account. This applies to Card accounts of accountType `prepaid`  only
 * @summary Top up account
 */
const topupCardAccount = <TData = AxiosResponse<CardAccountTransaction>>(
    topupCardAccountBody: TopupCardAccountBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cardaccounts/topup`,
      topupCardAccountBody,options
    );
  }

/**
 * Withdraw card account balance from card account to an account. This applies to Card accounts of accountType `prepaid` only
 * @summary Withdraw card account balance
 */
const withdrawCardAccount = <TData = AxiosResponse<CardAccountTransaction>>(
    withdrawCardAccountBody: WithdrawCardAccountBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cardaccounts/withdraw`,
      withdrawCardAccountBody,options
    );
  }

/**
 * Simulate repay card account
 * @summary simulate repay card account
 */
const simulateRepayCardAccount = <TData = AxiosResponse<SimulateRepayCardAccount200>>(
    simulateRepayCardAccountBody: SimulateRepayCardAccountBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cardaccounts/simulate-repay`,
      simulateRepayCardAccountBody,options
    );
  }

/**
 * Retrieves the Fees list.
 * @summary Get Fees
 */
const getFees = <TData = AxiosResponse<GetFees200>>(
    params?: GetFeesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/fees`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Instantly charge a fee to an account or card account. Fees charged will be reflected in the account balance immediately.
 * @summary Charge Fee
 */
const chargeFee = <TData = AxiosResponse<FeeEntry>>(
    chargeFeeBody: ChargeFeeBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/fees/charge`,
      chargeFeeBody,options
    );
  }

/**
 * Waive a charged fee entry. Fees wavied will be reflected in the account balance immediately.
 * @summary Waive a Fee
 */
const waiveFee = <TData = AxiosResponse<FeeEntry>>(
    waiveFeeBody: WaiveFeeBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/fees/waive`,
      waiveFeeBody,options
    );
  }

/**
 * @summary Get exchange rates for a given base currency
 */
const getRates = <TData = AxiosResponse<GetRates200>>(
    params: GetRatesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/rates`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Get bank data by Swift code
 */
const getBanks = <TData = AxiosResponse<GetBanks200>>(
    params: GetBanksParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/banks`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Name Check Results
 */
const getNameCheckId = <TData = AxiosResponse<GetNameCheckId200>>(
    id: string, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/name-check/${id}`,options
    );
  }

/**
 * @summary New Name Check
 */
const postNameCheck = <TData = AxiosResponse<PostNameCheck200>>(
    postNameCheckBody: PostNameCheckBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/name-check`,
      postNameCheckBody,options
    );
  }

/**
 * Set xmetadata for a entity id and type. The value passed to xid or xmetadata will replace the existing xid or xmetadata values respectively.
To remove xid or xmetadata, pass in null value.

 * @summary Set xmetadata
 */
const postXmetadataSet = <TData = AxiosResponse<PostXmetadataSet200>>(
    postXmetadataSetBody: PostXmetadataSetBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/xmetadata/set`,
      postXmetadataSetBody,options
    );
  }

/**
 * @summary Download account transactions
 */
const getReportingAccountsTransactions = <TData = AxiosResponse<GetReportingAccountsTransactions200>>(
    params?: GetReportingAccountsTransactionsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/reporting/accounts/transactions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Download  card account transactions
 */
const getReportingCardaccountsTransactions = <TData = AxiosResponse<GetReportingCardaccountsTransactions200>>(
    params?: GetReportingCardaccountsTransactionsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/reporting/cardaccounts/transactions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Applicable to card accounts with account type: 'fixed-limit' only.
Adjust the credit limit for one or multiple card accounts.

The request body should contain either a single object or an array of objects, where each object represents a card account with its associated fixed limit.

- For a single card account:
  ```
  {
    "cardAccountId": "string",
    "limit": number
  }
  ```

- For multiple card accounts:
  ```
  [
    {
      "cardAccountId": "string",
      "limit": number
    },
    ...
  ]
  ```

The response will indicate whether the fixed limit was updated successfully or if there was an error.
The sum of all assigned limits must not exceed the credit limit of the loan value of collateral posted for the card program.

 * @summary Adjust limit
 */
const postCardaccountsFixedLimit = <TData = AxiosResponse<void>>(
    postCardaccountsFixedLimitBody: PostCardaccountsFixedLimitBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cardaccounts/fixed-limit`,
      postCardaccountsFixedLimitBody,options
    );
  }

/**
 * Update the identity information of a cardholder associated with a specific card account.
 * @summary Update client identity information for a card account
 */
const postCardaccountsClientIdentity = <TData = AxiosResponse<PostCardaccountsClientIdentity200>>(
    postCardaccountsClientIdentityBody: PostCardaccountsClientIdentityBody, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.post(
      `/cardaccounts/client-identity`,
      postCardaccountsClientIdentityBody,options
    );
  }

/**
 * Retrieve the identity information of a cardholder associated with a specific card account.
 * @summary Get client identity information for a card account
 */
const getCardaccountsClientIdentity = <TData = AxiosResponse<GetCardaccountsClientIdentity200>>(
    params: GetCardaccountsClientIdentityParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/cardaccounts/client-identity`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Retrieves the balances of account(s).
 * @summary Get Ui Balances
 */
const getUiAccountsBalances = <TData = AxiosResponse<GetUiAccountsBalances200>>(
    params?: GetUiAccountsBalancesParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/ui/accounts/balances`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * Get a collection of Accounts based on provided search criteria.
 * @summary Get Ui Accounts
 */
const uiListAccounts = <TData = AxiosResponse<UiListAccounts200>>(
    params?: UiListAccountsParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/ui/accounts`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * This endpoint is only available for funds accounts associated with fixed limit card accounts.
 * @summary Get account credit summary
 */
const getAccountsCreditSummary = <TData = AxiosResponse<GetAccountsCreditSummary200>>(
    params: GetAccountsCreditSummaryParams, options?: AxiosRequestConfig
 ): Promise<TData> => {
    return axios.get(
      `/accounts/credit-summary`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

return {pingGet,pingPost,getSummary,listCountries,listPositions,listOccupations,removeWebhook,listWebhooks,createWebhook,listAccounts,createAccount,updateAccountName,addAssetsToAccount,removeAssetFromAccount,getAccountsBalances,postAccountsTransfers,getAccountTransactions,getCardAccounts,createCardAccount,issueCard,getCards,getCardAccountTransactions,activateCard,suspendCard,unsuspendCard,lockCard,unlockCard,cancelCard,getCardSensitiveDetails,changeCardPin,postCardsSpendingControls,updateCardPhoneNumber,simulateAuthorization,simulateCapture,verifyCardInfo,getSupportedDigitalAssets,getSupportedBlockchains,withdrawDigitalAsset,getDepositAddresses,generateDepositAddress,getPayouts,createPayout,validatePayout,getPayoutQuote,getConversionQuote,executeQuotedTrade,transferCardAccount,topupCardAccount,withdrawCardAccount,simulateRepayCardAccount,getFees,chargeFee,waiveFee,getRates,getBanks,getNameCheckId,postNameCheck,postXmetadataSet,getReportingAccountsTransactions,getReportingCardaccountsTransactions,postCardaccountsFixedLimit,postCardaccountsClientIdentity,getCardaccountsClientIdentity,getUiAccountsBalances,uiListAccounts,getAccountsCreditSummary}};
export type PingGetResult = AxiosResponse<Ping>
export type PingPostResult = AxiosResponse<Ping>
export type GetSummaryResult = AxiosResponse<GetSummary200>
export type ListCountriesResult = AxiosResponse<ListCountries200AllOf>
export type ListPositionsResult = AxiosResponse<ListPositions200AllOf>
export type ListOccupationsResult = AxiosResponse<ListOccupations200AllOf>
export type RemoveWebhookResult = AxiosResponse<Webhook>
export type ListWebhooksResult = AxiosResponse<ListWebhooks200>
export type CreateWebhookResult = AxiosResponse<Webhook>
export type ListAccountsResult = AxiosResponse<ListAccounts200>
export type CreateAccountResult = AxiosResponse<Account>
export type UpdateAccountNameResult = AxiosResponse<UpdateAccountName200>
export type AddAssetsToAccountResult = AxiosResponse<Account>
export type RemoveAssetFromAccountResult = AxiosResponse<Account>
export type GetAccountsBalancesResult = AxiosResponse<GetAccountsBalances200>
export type PostAccountsTransfersResult = AxiosResponse<AccountTransfer>
export type GetAccountTransactionsResult = AxiosResponse<GetAccountTransactions200>
export type GetCardAccountsResult = AxiosResponse<GetCardAccounts200>
export type CreateCardAccountResult = AxiosResponse<CardAccount>
export type IssueCardResult = AxiosResponse<Card>
export type GetCardsResult = AxiosResponse<GetCards200>
export type GetCardAccountTransactionsResult = AxiosResponse<GetCardAccountTransactions200>
export type ActivateCardResult = AxiosResponse<Card>
export type SuspendCardResult = AxiosResponse<Card>
export type UnsuspendCardResult = AxiosResponse<Card>
export type LockCardResult = AxiosResponse<Card>
export type UnlockCardResult = AxiosResponse<Card>
export type CancelCardResult = AxiosResponse<Card>
export type GetCardSensitiveDetailsResult = AxiosResponse<GetCardSensitiveDetails200>
export type ChangeCardPinResult = AxiosResponse<void>
export type PostCardsSpendingControlsResult = AxiosResponse<Card>
export type UpdateCardPhoneNumberResult = AxiosResponse<UpdateCardPhoneNumber200>
export type SimulateAuthorizationResult = AxiosResponse<SimulateAuthorization200>
export type SimulateCaptureResult = AxiosResponse<SimulateCapture200>
export type VerifyCardInfoResult = AxiosResponse<VerifyCardInfo200>
export type GetSupportedDigitalAssetsResult = AxiosResponse<DigitalAsset[]>
export type GetSupportedBlockchainsResult = AxiosResponse<Blockchain[]>
export type WithdrawDigitalAssetResult = AxiosResponse<DigitalWithdrawalRequest>
export type GetDepositAddressesResult = AxiosResponse<GetDepositAddresses200>
export type GenerateDepositAddressResult = AxiosResponse<DigitalDepositAddress[]>
export type GetPayoutsResult = AxiosResponse<GetPayouts200>
export type CreatePayoutResult = AxiosResponse<Payout>
export type ValidatePayoutResult = AxiosResponse<ValidatePayout200>
export type GetPayoutQuoteResult = AxiosResponse<PayoutQuote>
export type GetConversionQuoteResult = AxiosResponse<GetConversionQuote200>
export type ExecuteQuotedTradeResult = AxiosResponse<ExecuteQuotedTrade200>
export type TransferCardAccountResult = AxiosResponse<CardAccountTransaction>
export type TopupCardAccountResult = AxiosResponse<CardAccountTransaction>
export type WithdrawCardAccountResult = AxiosResponse<CardAccountTransaction>
export type SimulateRepayCardAccountResult = AxiosResponse<SimulateRepayCardAccount200>
export type GetFeesResult = AxiosResponse<GetFees200>
export type ChargeFeeResult = AxiosResponse<FeeEntry>
export type WaiveFeeResult = AxiosResponse<FeeEntry>
export type GetRatesResult = AxiosResponse<GetRates200>
export type GetBanksResult = AxiosResponse<GetBanks200>
export type GetNameCheckIdResult = AxiosResponse<GetNameCheckId200>
export type PostNameCheckResult = AxiosResponse<PostNameCheck200>
export type PostXmetadataSetResult = AxiosResponse<PostXmetadataSet200>
export type GetReportingAccountsTransactionsResult = AxiosResponse<GetReportingAccountsTransactions200>
export type GetReportingCardaccountsTransactionsResult = AxiosResponse<GetReportingCardaccountsTransactions200>
export type PostCardaccountsFixedLimitResult = AxiosResponse<void>
export type PostCardaccountsClientIdentityResult = AxiosResponse<PostCardaccountsClientIdentity200>
export type GetCardaccountsClientIdentityResult = AxiosResponse<GetCardaccountsClientIdentity200>
export type GetUiAccountsBalancesResult = AxiosResponse<GetUiAccountsBalances200>
export type UiListAccountsResult = AxiosResponse<UiListAccounts200>
export type GetAccountsCreditSummaryResult = AxiosResponse<GetAccountsCreditSummary200>
